// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3608":"192a12ce77acf485","8479":"4904d82dddc35b5c","9410":"0ae301dc9193205b"}[chunkId] + ".js";
};